import type { DocNode } from '@atlaskit/adf-schema';
import type { PublicPluginAPI } from '@atlaskit/editor-common/types';
import { areNodesEqualIgnoreAttrs } from '@atlaskit/editor-common/utils/document';
import type { Node as PMNode } from '@atlaskit/editor-prosemirror/model';
import type { AIPlugin } from '@atlassian/editor-plugin-ai';

import { findNodeByLocalIdAndDoc } from './find-node-by-local-id';
import { makeDocumentValid } from './make-document-valid';

type API = PublicPluginAPI<[AIPlugin]> | undefined;

/**
 * Determine if the change to the node (by its local id) is only its attributes
 *
 * @param initialDoc
 * @param finalNode
 * @param localId
 * @returns boolean whether the change is an attribute only change
 */
export function isAttributeOnlyChange(
	api: API,
	initialNode: PMNode | undefined,
	finalNode: DocNode | undefined,
): boolean {
	const schema = api?.core.sharedState.currentState()?.schema;
	if (!initialNode || !finalNode || !schema || !initialNode.attrs.localId) {
		return false;
	}
	const finalPMDoc = makeDocumentValid(api, finalNode)?.doc;
	if (!finalPMDoc) {
		return false;
	}
	const finalPMNode = findNodeByLocalIdAndDoc(finalPMDoc, initialNode.attrs.localId)?.node;
	return (
		(finalPMNode &&
			!initialNode.eq(finalPMNode) &&
			areNodesEqualIgnoreAttrs(initialNode, finalPMNode)) ??
		false
	);
}
